var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19H14.5M14.5 19C14.5 17.8954 13.6046 17 12.5 17C11.3954 17 10.5 17.8954 10.5 19M14.5 19C14.5 20.1046 13.6046 21 12.5 21C11.3954 21 10.5 20.1046 10.5 19M10.5 19H4.5M20.5 12L8.5 12M8.5 12C8.5 10.8954 7.6046 10 6.5 10C5.3954 10 4.5 10.8954 4.5 12C4.5 13.1046 5.3954 14 6.5 14C7.6046 14 8.5 13.1046 8.5 12ZM16.5 5L4.5 5M16.5 5C16.5 6.1046 17.3954 7 18.5 7C19.6046 7 20.5 6.1046 20.5 5C20.5 3.8954 19.6046 3 18.5 3C17.3954 3 16.5 3.8954 16.5 5Z",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilters);
export default __webpack_public_path__ + "static/media/icon-filters.c2bd44528bccad3cf4b9ca87d7d68858.svg";
export { ForwardRef as ReactComponent };